import ProductPricesDb from '../store/ProductsPricesStore';

import { fetchFromJson } from './fetchFromJson';

const db = new ProductPricesDb('productsPricesDb');

const updateCache = 'productsPrices_updateCache';
const getUpdateCache = (data) => data.prices;
const toast = 'Prices Updated';
const entityName = 'productsPrices';

export default (WrappedComponent) => fetchFromJson({
  WrappedComponent,
  getUpdateCache,
  db,
  updateCache,
  toast,
  entityName,
  willFetch: () => localStorage.removeItem('cacheForPrice'),
});
